:host {
    display: block;
}

afs-button {
    position: relative;
    margin: 5px 10px;

    @media screen and (max-width: 767px) {
        width: 85px !important;
        margin: 5px;
    }
}

.check-container {
    position: absolute;
    left: 7px;
    top: 7px;
    width: 28px;
    height: 28px;
    border-radius: 50%;

    @media screen and (max-width: 767px) {
        left: 5px;
        top: 9px;
        width: 21px;
        height: 21px;
    }
}

.check {
    position: absolute;
    border-bottom: 2px solid;
    border-left: 2px solid;
    height: 5px;
    width: 12px;
    top: 10px;
    left: 8px;
    transform: rotate(-45deg);

    @media screen and (max-width: 767px) {
        left: 5px;
        top: 7px;
    }
}